export default function LoadingScreen() {
  return (
    <div className="flex h-screen items-center justify-center bg-gray-950 text-white">
      Loading...
    </div>
  )
}
